import {
    Attr
} from '@vuex-orm/core'

export default class ArrayAttr extends Attr {
    
    constructor(
        model, 
        value, 
        keys, 
        mutator
    ) {
        super(model, 
            value, 
            mutator)
        this.keys = keys || []
    }

    toString(name) {
        return name + ' { ' + this.keys.join(' ') + '}' 
    }
}